<template>
  <v-autocomplete
    label="Audience Name"
    outlined
    dense
    clearable
    :items="sortedOptions"
    item-text="Name"
    item-value="Value"
    v-model="selected"
    class="md4"
    id="appendFileModalAudienceNameSelect"
    @input="val => update(val)"
    :search-input.sync="search"
    return-object
    hide-details="true"
  >
  </v-autocomplete>
</template>

<script>
import {getTargetsByTargetType} from '@/api'
import { sortBy } from 'lodash'

export default {
  props: {
    initialValue: null,
    targetType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      options: [],
      sortedOptions: [],
      isLoading: false,
      isSelected: false,
      selected: null,
      search: null,
    }
  },
  mounted () {
    this.setOptions()
  },
  methods: {
    setOptions () {
      getTargetsByTargetType({target_type: this.targetType}).then(data => {
        this.options = data.data.map(d => {
          return {Name: d.display_name, Value: d}
        })
      })
    },
    update (val) {
      if (!val) {
        this.isSelected = false
        let sortedResults = sortBy(this.options, obj => obj.Name)
        this.sortedOptions = sortedResults
      } else {
        this.isSelected = true
        this.$emit('input', val ? val.Value : null)
      }
    },
    clear () {
      this.$refs.select.clear()
    }
  },
  watch: {
    targetType () {
      this.setOptions()
    },
    initialValue () {
      if (this.initialValue != null) {
        this.selected = {Name: this.initialValue.display_name, Value: this.initialValue}
        this.isSelected = true
        this.sortedOptions = [this.selected]
      }
    },
    search (val) {
      if (typeof val === 'string' && val.length >= 2) {
        // Items have already been requested or selected
        if (this.isLoading || this.isSelected) return

        this.isLoading = true
        let sortedResults = sortBy(this.options, obj => obj.Name)
        this.sortedOptions = sortedResults
        this.isLoading = false
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// TargetDDL.vue?fb3c32f6